@if (control) {
  <div [class]="wrapperClass + ' text-start'">
    <div class="position-relative">
      @if (label && label.length) {
        <label [for]="id + '_input'" [innerHTML]="label + ((controlIsRequired$ | async) && showRequiredStar ? ' <em class=&quot;text-danger&quot;>*</em>' : '')"></label>
      }
      @if (!suffix) {
        <ng-container [ngTemplateOutlet]="input"></ng-container>
      }
      @if (suffix) {
        <div class="input-group">
          <ng-container [ngTemplateOutlet]="input"></ng-container>
          <div [class]="'input-group-append ' + (suffixContainerClass ?? '')" (click)="suffixClicked.emit($event)">
            <span [innerHtml]="suffix" class="input-group-text"></span>
          </div>
        </div>
      }
      @if ((type === 'password' || passwordVisible) && !!control.value?.length) {
        <i (click)="passwordVisible = !passwordVisible; type = passwordVisible ? 'text' : 'password'"
           [class.fa-eye-slash]="passwordVisible"
           [class.fa-eye]="!passwordVisible"
           class="password-peek fa"></i>
      }
    </div>
    @if (showPasswordMeter) {
      <input-password-meter [barLabel]="passwordMeterLabel" [passControl]="control"></input-password-meter>
    }
    <input-error-output [control]="control" [customErrorMessage]="customErrorMessage"></input-error-output>
  </div>
}

<ng-template #input>
  <input #inputElement
         [attr.autofocus]="autofocusInput ? true :  null"
         [autocomplete]="autocomplete"
         [class.password-peek-padding]="passwordVisible || type === 'password'"
         [class]="inputClass + ' position-relative'"
         [formControl]="control"
         [id]="id + '_input'"
         [attr.autocapitalize]="autocapitalize ? autocapitalize : null"
         [placeholder]="placeholder"
         [readOnly]="readonly"
         [type]="type">
</ng-template>
